import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Marker } from 'react-google-maps'
import { setMarkerParams, onCloseMarkerInfo } from 'reducers/seaLice/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import defaultMarker from 'assets/img/mysites-marker.svg'
import defaultRedMarker from 'assets/img/mysites-red-marker.svg'
import defaultMarkerSelected from 'assets/img/mysites-marker-select.svg'
import defaultRedMarkerSelected from 'assets/img/mysites-red-marker-select.svg'

class MySitesMarkerList extends Component {
  componentDidMount() {
    this.setActiveMarker()
  }

  componentWillUnmount() {
    this.props.onCloseMarkerInfo()
  }

  setActiveMarker = () => {
    const { activeSite, sitesData } = this.props

    sitesData.toArray().forEach(site => {
      if (site.site_id === activeSite) {
        const latLng = {
          latLng: {
            lat: site.location.latitude,
            lng: site.location.longitude,
          },
        }

        this.props.setMarkerParams({
          position: latLng,
          marker: site,
        })
      }
    })
  }

  onMarkerClick = (mapObj, site) => {
    const { activeSite, setSiteContext, setMarkerParams } = this.props
    const siteId = site.site_id

    setMarkerParams({
      position: mapObj,
      marker: site,
    })

    if (siteId !== activeSite) {
      setSiteContext({ site: siteId })
    }
  }

  render() {
    const { activeSite, activeType } = this.props
    const sitesData = this.props.sitesData.toArray()

    if (sitesData.length === 0) {
      return null
    }

    return (
      <>
        {sitesData.map(site => {
          const typeValue = site.weeks[5][activeType]

          if (site.location) {
            return (
              <Marker
                key={site.site_id}
                onClick={mapObj => this.onMarkerClick(mapObj, site)}
                title={site.site_name}
                position={{
                  lat: site.location.latitude,
                  lng: site.location.longitude,
                }}
                label={{
                  text: typeValue ? `${typeValue}` : 'N/A',
                  fontSize: '11px',
                }}
                icon={{
                  url:
                    // eslint-disable-next-line no-nested-ternary
                    Number(typeValue) >= 3
                      ? activeSite && activeSite === site.site_id
                        ? defaultRedMarkerSelected
                        : defaultRedMarker
                      : activeSite && activeSite === site.site_id
                      ? defaultMarkerSelected
                      : defaultMarker,
                  scaledSize:
                    activeSite && activeSite === site.site_id
                      ? new window.google.maps.Size(52, 60)
                      : new window.google.maps.Size(42, 50),
                }}
              />
            )
          }

          return null
        })}
      </>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeType: state.getIn(['seaLice', 'activeType']),
    startDate: state.getIn(['mortality', 'startMortalityDate']),
    endDate: state.getIn(['mortality', 'endMortalityDate']),
  }),
  {
    setMarkerParams,
    setSiteContext,
    onCloseMarkerInfo,
  },
)(MySitesMarkerList)
